module.exports = __webpack_public_path__ + "components/country-flag/static/ps-1f55b389dded73202a91fb93acc198ff.svg";